import { render, staticRenderFns } from "./experience-question.vue?vue&type=template&id=aaa60684"
import script from "./experience-question.vue?vue&type=script&lang=js"
export * from "./experience-question.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports